<h2 class="default-dialog-header" mat-dialog-title>
	<span fxFlex>Notes</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer">close</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content class="modal-content">
	<app-note-list
		[id]="carrierNoteType() ? carrierId : projectId"
		[supportId]="carrierNoteType() ? projectId : carrierId"
		[name]="name"
		[showFeedback]="false"
		[noteType]="noteType"
	>
	</app-note-list>
	<div #lastDiv></div>
</mat-dialog-content>
